<template>
  <b-card>
    <b-row>
      <!-- User Info: Left col -->
      <b-col
        cols="12"
        xl="12"
        class="d-flex justify-content-between flex-column"
      >
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-column">
            <div class="mb-1">
              <h4 class="mb-0">
                {{ workplace ? workplace.name : '-' }}
              </h4>
              <span class="card-text">{{ institutionData.name }}</span>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BCard, BRow, BCol,
  },
  props: {
    institutionData: {
      type: Object,
      required: true,
    },
    workplace: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      avatarText,
    }
  },
}
</script>

<style>

</style>
